import { Api } from "./api"

export class SupplierApi extends Api {
  constructor() {
    super('suppliers', [])
  }
}
